import { Flex, Typography } from "antd";
import { observer } from "mobx-react-lite";

import { FILE_TYPE_ENUM } from "interfaces";
import { useStores } from "stores";
import { EditableFile, WhiteBoxBlock } from "ui";
import { fileExistsInObject } from "utils";

export const CompanyFilesBlock = observer(() => {
  const { companyCard } = useStores();
  const { documents } = companyCard.card;
  return (
    <WhiteBoxBlock>
      <Flex vertical gap="middle">
        <Typography.Text strong className="whitebox-title">
          Файлы
        </Typography.Text>
        <Flex vertical gap="large">
          {fileExistsInObject(documents, FILE_TYPE_ENUM.OFFER_SIGNED) &&
            documents[FILE_TYPE_ENUM.OFFER_SIGNED].map((item) => (
              <EditableFile key={item.id} file={item} tooltip="Оферта" />
            ))}
        </Flex>
      </Flex>
    </WhiteBoxBlock>
  );
});
